import SettingsTasksList from './list'


if (document.body.getAttribute("data-current-path") === "settings/tasks") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new SettingsTasksList();
    }
}